module.exports = __webpack_public_path__ + "static/media/ico_money.666650cc.svg";